function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { dateType, STANDARD_TEXT, TSS_DARK_BLUE, TSS_BLUE_1, DATE_FORMAT, DATE_TIME_FORMAT, stylePropType, getScrollParent } from 'tss-core-lib-common';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import Icon from 'react-svg-ikon';

import DatePicker from './DatePicker';
import clickOutsideEnhancer from './clickOutsideEnhancer';
import withRefs from './withRefsEnhancer';
import { IMG_ICON_CHEVRON_DOWN_SMALL } from '../img';

var styles = void 0;

var enhance = compose(withState('open', 'setOpen', false), withState('above', 'setAbove', function (props) {
  return Boolean(props.above);
}), withHandlers({
  onClickOutside: function onClickOutside(props) {
    return function (event) {
      var container = props.getRef('container');
      if (container && event.target !== container && !container.contains(event.target)) {
        setTimeout(function () {
          return props.setOpen(false);
        }, 50);
      }
    };
  },

  onClick: function onClick(props) {
    return function (event) {
      if (event.target === props.getRef('container') || event.target === props.getRef('span')) {
        var _event$target$getBoun = event.target.getBoundingClientRect(),
            bottom = _event$target$getBoun.bottom;

        var scrollParent = getScrollParent(event.target);
        var height = window.innerHeight;
        if (scrollParent) {
          height = scrollParent.getBoundingClientRect().bottom;
        }
        props.setAbove(bottom + 350 > height);
        setTimeout(function () {
          return props.setOpen(true);
        }, 0);
      }
    };
  },

  onChange: function onChange(props) {
    return function () {
      props.setOpen(false);
      if (props.onChange) {
        props.onChange.apply(props, arguments);
      }
    };
  },

  onTimeChange: function onTimeChange(props) {
    return function () {
      return props.onChange && props.onChange.apply(props, arguments);
    };
  }
}));

var getFormat = function getFormat(format, showTime) {
  if (format) {
    return format;
  }

  return showTime ? DATE_TIME_FORMAT : DATE_FORMAT;
};

var DatePickerInput = function DatePickerInput(_ref) {
  var setRef = _ref.setRef,
      dateFormat = _ref.dateFormat,
      timezone = _ref.timezone,
      open = _ref.open,
      above = _ref.above,
      placeholder = _ref.placeholder,
      isStatic = _ref.isStatic,
      onClick = _ref.onClick,
      style = _ref.style,
      containerStyle = _ref.containerStyle,
      props = _objectWithoutProperties(_ref, ['setRef', 'dateFormat', 'timezone', 'open', 'above', 'placeholder', 'isStatic', 'onClick', 'style', 'containerStyle']);

  return React.createElement(
    'div',
    {
      className: css(style, styles.container, isStatic && styles.staticContainer, isStatic && open && styles.openStaticContainer),
      ref: setRef('container'),
      onClick: onClick
    },
    React.createElement(
      'span',
      { ref: setRef('span'), className: css(STANDARD_TEXT) },
      props.value ? props.value.format(getFormat(dateFormat, props.showTimePicker)) : placeholder || ''
    ),
    isStatic ? React.createElement(Icon, { src: IMG_ICON_CHEVRON_DOWN_SMALL, color: TSS_DARK_BLUE(), style: styles.icon }) : null,
    open ? React.createElement(
      'div',
      { className: css(styles.datepickerContainer, containerStyle, above && styles.datepickerContainerAbove) },
      React.createElement(DatePicker, Object.assign({ timezone: timezone }, props))
    ) : null
  );
};

DatePickerInput.propTypes = {
  value: dateType,
  open: PropTypes.bool.isRequired,
  setRef: PropTypes.func.isRequired,
  dateFormat: PropTypes.string,
  timezone: PropTypes.string,
  above: PropTypes.bool.isRequired,
  showTimePicker: PropTypes.bool,
  placeholder: PropTypes.string,
  isStatic: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  style: stylePropType,
  containerStyle: stylePropType
};

DatePickerInput.defaultProps = {
  value: null,
  dateFormat: null,
  style: null,
  containerStyle: null,
  timezone: 'UTC',
  isStatic: false,
  placeholder: null,
  showTimePicker: false
};

styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: 'white',
    border: '2px solid ' + TSS_BLUE_1(),
    color: TSS_DARK_BLUE(),
    cursor: 'text',
    display: 'flex',
    fontSize: '1.6rem',
    height: '4.6rem',
    minWidth: '23rem',
    padding: '0 0 0 1.4rem',
    position: 'relative'
  },

  staticContainer: {
    backgroundColor: 'transparent',
    minWidth: 'initial',
    padding: '0 1.4rem',
    cursor: 'pointer'
  },

  openStaticContainer: {
    backgroundColor: TSS_DARK_BLUE(0.15)
  },

  datepickerContainer: {
    position: 'absolute',
    top: '100%',
    width: '100%',
    minWidth: '28rem',
    right: -1,
    marginTop: 1,
    zIndex: 100
  },

  datepickerContainerAbove: {
    top: 'initial',
    bottom: '100%',
    marginBottom: 1
  },

  icon: {
    marginLeft: '1rem'
  }
});

export default withRefs(enhance(clickOutsideEnhancer(DatePickerInput, 'onClickOutside')));